import styled from 'styled-components';

export const StickyFooterBar = styled.div`
  padding-bottom: max(env(safe-area-inset-bottom), 3rem);
  width: 100%;
  background-color: ${props => props.theme.colors.white} !important;
  position: fixed;
  bottom: 0%;
  /* Copied directly from figma */
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);

  z-index: 1;

  display: none;
  ${props => props.theme.mediaQueries.smallDown} {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
  }
`;
